import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}`;

export const fetchMetaData = async (moduleName: string) => {
  const res = await api.get(`${apiEndPoint}/${moduleName}`, {
    params: {
      page: 1,
      size: 1000000,
      search: "",
    },
  });

  return res;
};
